import { render, staticRenderFns } from "./HelptableGrid.vue?vue&type=template&id=a33067c4"
import script from "./HelptableGrid.vue?vue&type=script&lang=js"
export * from "./HelptableGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports